function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as Model from '../models';
import MemoryCache from '../cache/memory-cache';
import ObservableCacheWrapper from '../cache/observable-cache-wrapper';
import SerializingCacheWrapper from '../cache/serializing-cache-wrapper';
import Database from '../db-cache/database';
import DbCache from '../db-cache/db-cache';
import { toKey } from '../models/item-key';
var DB_NAME = 'onvio.dms.cache';
var DB_VERSION = 8;
var DbStoreNames = /*#__PURE__*/function (DbStoreNames) {
  DbStoreNames["Children"] = "children";
  DbStoreNames["Parents"] = "parents";
  DbStoreNames["Types"] = "types";
  DbStoreNames["CommentCount"] = "commentCount";
  DbStoreNames["ApprovalStatus"] = "approvalStatus";
  return DbStoreNames;
}(DbStoreNames || {});
function dbInitializer(db, oldVersion) {
  if (oldVersion) {
    console.log("Upgrading DMS Cache DB v".concat(oldVersion, " -> v").concat(DB_VERSION));
  } else {
    console.log("Initializing DMS Cache DB v".concat(DB_VERSION));
  }
  db.removeAll();
  db.createStore(DbStoreNames.Children, true);
  db.createStore(DbStoreNames.Parents, true);
  db.createStore(DbStoreNames.Types);
  db.createStore(DbStoreNames.CommentCount);
  db.createStore(DbStoreNames.ApprovalStatus);
}
export function setChanged(changed) {
  return function (a, b) {
    return a.length !== b.length || a.some(function (elA, i) {
      return changed(elA, b[i]);
    });
  };
}
export var keyListChanged = setChanged(function (a, b) {
  return a.id !== b.id;
});
var DmsStores = /*#__PURE__*/function () {
  function DmsStores() {
    _classCallCheck(this, DmsStores);
    this.items = void 0;
    this.children = void 0;
    this.parents = void 0;
    this.commentCounts = void 0;
    this.comments = void 0;
    this.approvalStatus = void 0;
    this.clients = void 0;
    this.shares = void 0;
    this.containerLoadingState = void 0;
    if (DmsStores.instantiated) {
      throw new Error('Duplicate instance of DmsStores requested.');
    }
    var childCache;
    var parentCache;
    var commentCountCache;
    var approvalStatusCache;
    if (Database.hasSupport()) {
      var db = new Database(DB_NAME, DB_VERSION, dbInitializer);
      childCache = new DbCache(DbStoreNames.Children, db, true, function (a) {
        return a.map(toKey);
      });
      parentCache = new DbCache(DbStoreNames.Parents, db, true, toKey);
      commentCountCache = new DbCache(DbStoreNames.CommentCount, db);
      approvalStatusCache = new DbCache(DbStoreNames.ApprovalStatus, db);
    } else {
      console.log('IndexedDB not supported, DMS falling back to Memory cache');
      childCache = new MemoryCache(true);
      parentCache = new MemoryCache(true);
      commentCountCache = new MemoryCache();
      approvalStatusCache = new MemoryCache();
    }
    this.children = new ObservableCacheWrapper(new SerializingCacheWrapper(childCache), {
      isChanged: keyListChanged,
      defaultValue: []
    });
    this.parents = new ObservableCacheWrapper(new SerializingCacheWrapper(parentCache));
    this.commentCounts = new ObservableCacheWrapper(new SerializingCacheWrapper(commentCountCache));
    this.approvalStatus = new ObservableCacheWrapper(new SerializingCacheWrapper(approvalStatusCache), {
      isChanged: Model.ApprovalRequestStatus.changed
    });

    // These caches potentially contain sensitive information,
    // so until or unless a method of securing the cache is developed,
    // we will limit these to in-memory cache.
    this.comments = new ObservableCacheWrapper(new SerializingCacheWrapper(new MemoryCache()), {
      isChanged: setChanged(Model.Comment.changed)
    });
    this.items = new ObservableCacheWrapper(new SerializingCacheWrapper(new MemoryCache(true)));
    this.clients = new ObservableCacheWrapper(new SerializingCacheWrapper(new MemoryCache()), {
      isChanged: setChanged(Model.Client.changed)
    });
    this.shares = new ObservableCacheWrapper(new SerializingCacheWrapper(new MemoryCache()));

    // This data is ephemeral - at least unless or until we can persistently cache tree data
    this.containerLoadingState = new ObservableCacheWrapper(new SerializingCacheWrapper(new MemoryCache()), {
      defaultValue: Model.LoadingState.none
    });
  }
  return _createClass(DmsStores, null, [{
    key: "instantiated",
    get: function get() {
      return false;
    }
  }]);
}();
export { DmsStores as default };
